import React from 'react'
import GovernanceHero from '../governance/GovernanceHero'
import SideMenu from './SideMenu'
import { resultsdisclosures } from '../../js/ResultsDisclosures';

function ResultsDisclosures() {
    return (
        <div>
            <GovernanceHero headingText={'Corporate Announcements'} />

            <div className='mx-auto max-w-7xl py-8'>
                <div className='md:flex lg:flex xl:flex 2xl:flex'>
                    <div className='lg:px-6 md:px-6 xl:px-6 px-2 md:pb-6 lg:pb-6 xl:pb-6 pb-4 max-w-4xl w-full'>
                        <h2 class="my-4 text-2xl text-gray-700 font-bold">RESULTS & DISCLOSURE</h2>

                        <div className="relative overflow-x-auto p-2">
                            <video className="w-full" controls>
                                <source src="https://www.educomp.com/Data/educomp_29062020.mp4" type="video/mp4" />
                            </video>
                        </div>


                        <div class="relative overflow-x-auto  p-2">

                            <table class=" text-sm text-left rtl:text-right text-gray-500">

                                {resultsdisclosures.map(results => (
                                    <tbody>
                                        <tr class="border-b border-gray-200 ">
                                            <tr class="px-6 py-4">
                                                {results.Heading1}
                                            </tr>
                                            <td class="px-6 py-4">
                                                {results.Heading2}
                                            </td>

                                            <a href={results.PDF} target="_blank" rel="noopener noreferrer">
                                                <td class="px-6 py-4 text-[#2baf2b]">
                                                    Download
                                                </td>
                                            </a>
                                        </tr>

                                    </tbody>
                                ))}
                            </table>
                        </div>


                    </div>

                    <div className='md:px-0 lg:px-0 xl:px-0 2xl:px-0 px-3.5'>
                        <SideMenu />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ResultsDisclosures